import $ from 'jquery';

export default class isSafari {
    constructor() {
        let userAgentString = navigator.userAgent;
        let chromeAgent = userAgentString.indexOf("Chrome") > -1;
        let safariAgent = userAgentString.indexOf("Safari") > -1;
        if ((chromeAgent) && (safariAgent)) safariAgent = false;
        if(safariAgent){
            $('input[id^="data-urodzenia"]').toggleClass('is_safari');
        }
    }
}
